import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import profileDefault from "../images/profile.gif";
import axios from "axios";
import testBg from "../images/about/testBg.jpg";
import testimoimg from "../images/testimoimg.jpg";
import testimoimg2 from "../images/seller1.jpg";
import quotedUp from "../images/about/quoted-up.png";
import quotedDown from "../images/about/quoted-down.png";

const NewTestimonial = () => {
  const [gettestimonial, setGetTestimonial] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTestimonial = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/getTestimonial`
      );
      if (response.data.status === "success") {
        //alert(JSON.stringify(response.data.data));
        setGetTestimonial(response.data.data); // Set the property list
        setLoading(false);
      } else {
        setGetTestimonial([]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setGetTestimonial([]);
      setLoading(false);
    }
  };

  const testimonials = [
    {
      name: "Mrs. Preeti",
      description:
        "I'm impressed with the level of service and dedication shown by the Siddhiananta Group. They helped me navigate the complexities of buying an investment plot with ease.",
      image: testimoimg,
    },
    {
      name: "Mrs. Ankita ",
      description:
        "From the initial consultation to the closing, Siddhiananta Group provided exceptional support.They truly care about their clients' needs and deliver on their promises.",
      image: testimoimg2,
    },
    // Add more testimonials here...
  ];

  const PrevArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button className={`custom-arrow custom-prev`} onClick={onClick}>
        {"<"}
      </button>
    );
  };

  const NextArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button className={`custom-arrow custom-next`} onClick={onClick}>
        {">"}
      </button>
    );
  };
  // testimonial
  const settings1 = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  useEffect(() => {
    fetchTestimonial();
  }, []);
  return (
    <div>
      <section className="testimonial-section mb-5" style={{ height: "690px" }}>
        <div className="ownership-header">
          <div className="titleunderline">
            <svg
              width="64"
              height="3"
              viewBox="0 0 64 3"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 1.5H62"
                stroke="#F68633"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <h6 className="client-text mt-2">
            Words That Inspire Us — <br class="d-block d-md-none" />
            From Our Esteemed Clients
          </h6>
        </div>
        <div style={{ position: "relative" }} className="mt-5">
          <div className="testimonial-card">
            <Slider {...settings1}>
              {gettestimonial.map((item, index) => (
                <div
                  style={{ width: "90%", margin: "auto", overflow: "hidden" }}
                >
                  <div className="testimonial-card-top">
                    <div>
                      {item.image ? (
                        <img
                          className="testimonial-user-image"
                          src={item.image}
                          alt={item.name}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = "none";
                            e.target.nextSibling.style.display = "flex";
                          }}
                        />
                      ) : null}
                      <div
                        className="testmonialFirstLetterHome"
                        style={{ display: item?.image ? "none" : "flex" }}
                      >
                        {item?.name
                          ? item.name
                              .split(" ")
                              .map((word) => word.charAt(0).toUpperCase())
                              .join("")
                          : ""}
                      </div>
                    </div>
                    <div style={{ marginTop: "-13px" }}>
                      <p className="testimonial-user-name mb-0">{item.name}</p>
                      <div>
                        {Array(5)
                          .fill(0)
                          .map((_, i) => (
                            <svg
                              key={i}
                              width="22"
                              height="21"
                              viewBox="0 0 16 17"
                              fill="rgb(255, 213, 0)"
                              xmlns="http://www.w3.org/2000/svg"
                              stroke="rgb(255, 213, 0)"
                            >
                              <path
                                d="M7.51338 3.43946C7.66772 3.09321 7.74492 2.92008 7.85238 2.86677C7.94572 2.82045 8.05532 2.82045 8.14865 2.86677C8.25612 2.92008 8.33332 3.09321 8.48765 3.43946L9.71698 6.19742C9.76265 6.29978 9.78545 6.35096 9.82078 6.39015C9.85198 6.42483 9.89018 6.45257 9.93278 6.47156C9.98098 6.49302 10.0367 6.49891 10.1482 6.51067L13.151 6.8276C13.528 6.86739 13.7165 6.88728 13.8004 6.97301C13.8733 7.04747 13.9072 7.15174 13.892 7.25483C13.8745 7.3735 13.7337 7.50036 13.4521 7.75416L11.209 9.77563C11.1258 9.85063 11.0841 9.88817 11.0578 9.93383C11.0345 9.9743 11.0199 10.0192 11.015 10.0656C11.0095 10.118 11.0211 10.1728 11.0443 10.2825L11.6709 13.2363C11.7495 13.6072 11.7889 13.7926 11.7333 13.8988C11.6849 13.9912 11.5963 14.0556 11.4935 14.073C11.3753 14.093 11.2111 13.9984 10.8827 13.809L8.26698 12.3003C8.16992 12.2443 8.12138 12.2164 8.06978 12.2054C8.02412 12.1957 7.97692 12.1957 7.93125 12.2054C7.87965 12.2164 7.83112 12.2443 7.73405 12.3003L5.1184 13.809C4.79001 13.9984 4.62582 14.093 4.50754 14.073C4.4048 14.0556 4.31611 13.9912 4.26782 13.8988C4.21222 13.7926 4.25155 13.6072 4.33021 13.2363L4.95672 10.2825C4.97997 10.1728 4.9916 10.118 4.98608 10.0656C4.98119 10.0192 4.96661 9.9743 4.94328 9.93383C4.91691 9.88817 4.87528 9.85063 4.79204 9.77563L2.54896 7.75416C2.26735 7.50036 2.12654 7.3735 2.10904 7.25483C2.09384 7.15174 2.12771 7.04747 2.2006 6.97301C2.28452 6.88728 2.47302 6.86739 2.85002 6.8276L5.85288 6.51067C5.96434 6.49891 6.02006 6.49302 6.06824 6.47156C6.11088 6.45257 6.14905 6.42483 6.18029 6.39015C6.21559 6.35096 6.2384 6.29978 6.28404 6.19742L7.51338 3.43946Z"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ))}
                      </div>
                    </div>
                  </div>
                  <div
                    className="testimonial-description-container"
                    style={{ height: "175px", position: "relative" }}
                  >
                    <img className="quotedUp" src={quotedUp} alt="quoted " />
                    <p className="testimonial-user-description">
                      {item.description.split(" ").slice(0, 25).join(" ")}
                      {item.description.split(" ").length > 25 && "..."}
                    </p>
                    <img className="quotedDown" src={quotedDown} alt="quoted" />
                  </div>
                </div>
              ))}
            </Slider>
            <div>
              <p className="testimonial-salutaion">
                Thank you for your trust and support Siddhi Ananta Group is
                honored to serve you.
              </p>
            </div>
          </div>
          <div className="testimonial-slider-section desk">
            <img src={testBg} />
          </div>
        </div>
      </section>
    </div>
  );
};
export default NewTestimonial;
